import { render, staticRenderFns } from "./WsAppLayout.vue?vue&type=template&id=8f98a4a4&"
import script from "./WsAppLayout.vue?vue&type=script&lang=js&"
export * from "./WsAppLayout.vue?vue&type=script&lang=js&"
import style0 from "./WsAppLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VMain})
